import { useAzureAuth } from '../../../hooks/use_azure_auth.ts';
import { ReactNode, useState } from 'react';
import { Navigate } from 'react-router';

export function AzAuthCallBack(): ReactNode {
    const user = useAzureAuth();

    const [loginCompleted, setLoginCompleted] = useState(false);
    user.syncUserInformation().then(() => setLoginCompleted(true));

    if (loginCompleted) {
        return <Navigate to="/" />;
    } else {
        // Display an empty page until API token is retrieve to avoid retrieving drivers twice.
        return <></>;
    }
}
